import { DropdownItem, DropdownMenu, Icon } from "semantic-ui-react";

import { CircleIcon, Dropdown } from "components";
import "modules/Appointments/components/SpecialIndicators/SpecialIndicators.scss";
import { useGetCartIndicators } from "modules/Appointments/hooks";

const CartIndicators = () => {
  const { cartFilters, handleCartFilters } = useGetCartIndicators();

  if (cartFilters.length === 1) {
    const cart = cartFilters[0];
    return <CircleIcon icon={cart.icon} disabled={!cart.active} borderColor={cart.borderColor} color={cart.borderColor} onClick={() => handleCartFilters(0)} />;
  }
  const hasActiveFilters = cartFilters.some(e => e.active);

  return (
    <Dropdown
      className="carts-dropdown"
      icon={
        <>
          <Icon className="shopping cart shoppingCartIcon" />
          <Icon className={`cart-filter-icon ${hasActiveFilters ? "filters" : "filter"} `} />
        </>
      }
    >
      <DropdownMenu className="dropdown-menu-container">
        {cartFilters.map((cart, i) => (
          <DropdownItem selected={cart.active} key={i} onClick={() => handleCartFilters(i)} className={cart.active ? "cart-selected-option" : ""}>
            <Icon className={`shopping cart ${cart.borderColor === "orange" ? "orange-cart" : cart.borderColor}`} /> {cart.text}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default CartIndicators;
